import { FC } from 'react';

import { useAuthPageWrapperContext } from '../AuthPageWrapperContext';

interface InputGroupProps {
  title: string;
}

export const InputGroup: FC<InputGroupProps> = ({ title, children }) => {
  const { cnBem } = useAuthPageWrapperContext();

  return (
    <fieldset className={cnBem('__inputGroup')}>
      <legend>{title}</legend>
      {children}
    </fieldset>
  );
};
